import { DatabaseZap } from 'lucide-react';
import { Skeleton } from '@/components/ui/skeleton';
import { cn } from '@/lib/utils';
import { ColumnDisplayIcon } from '../../TeamDashboard/components/Shared';

/**
 * 大盘概览通用卡片容器
 */
export function MarketOverviewCard({
  className,
  children,
}: {
  /** 自定义样式 */
  className?: string;
  /** 卡片内容 */
  children: React.ReactNode;
}) {
  return (
    <section className={cn('rounded-xl border bg-card p-5 text-card-foreground', className)}>
      {children}
    </section>
  );
}

/**
 * 图表加载占位
 */
export function MarketOverviewChartLoading() {
  return (
    <div
      data-testid="market-overview-chart-loading"
      className="flex h-full items-end gap-3 px-2 pb-2 pt-8"
      aria-hidden="true"
    >
      {[58, 78, 48, 88, 67, 92, 62].map((height, index) => (
        <Skeleton
          key={`${height}-${index}`}
          className="flex-1 rounded-t-sm"
          style={{ height: `${height}%` }}
        />
      ))}
    </div>
  );
}

/**
 * 折线图加载占位
 * 供报表中心及复用其图表规范的页面保持一致的加载反馈
 */
export function MarketOverviewLineChartLoading() {
  return (
    <div
      data-testid="efficiency-trend-loading-skeleton"
      className="relative h-full overflow-hidden"
      aria-hidden="true"
    >
      <div className="absolute inset-x-0 top-4 flex flex-col gap-[44px]">
        {Array.from({ length: 5 }).map((_, index) => (
          <Skeleton key={index} className="h-px w-full rounded-none" />
        ))}
      </div>
      <Skeleton className="absolute bottom-8 left-6 right-6 h-1 w-auto rounded-full" />
      <Skeleton className="absolute bottom-20 left-10 right-10 h-1 w-auto rotate-[-6deg] rounded-full" />
    </div>
  );
}

/**
 * 图表无数据状态
 */
export function MarketOverviewEmpty({ description = '暂无数据' }: { description?: string }) {
  return (
    <div className="flex h-full flex-col items-center justify-center gap-2 text-muted-foreground">
      <DatabaseZap className="size-8 opacity-40" />
      <span className="text-sm">{description}</span>
    </div>
  );
}

/**
 * 设计稿同款悬浮配置入口
 */
export function MarketOverviewConfigButton({
  onClick,
  label,
}: {
  /** 点击回调 */
  onClick: () => void;
  /** 无障碍名称 */
  label: string;
}) {
  return (
    <button
      type="button"
      aria-label={label}
      className="flex size-4 cursor-pointer items-center justify-center rounded-md text-muted-foreground opacity-0 transition hover:bg-accent hover:text-accent-foreground group-hover:opacity-100 focus-visible:opacity-100"
      onClick={onClick}
    >
      <ColumnDisplayIcon />
    </button>
  );
}
